import React from 'react'
import Main from '../Widgets/Main'
import Nav from '../Widgets/Nav'
import Footer from '../Widgets/Footer'



const Home = () => (
    <div className="index">
        <Nav />
        <Main />
        <Footer />
    </div>

)

export default Home